import React, { Component } from "react";
import { Sticky, Input } from "semantic-ui-react";
import { connect } from "react-redux";
import classNames from "classnames";
import { resetConnection, setAutofocus } from "../../../store/actions/connection";
import { withRouter } from "react-router-dom";
import { resetServices } from "../../../store/actions/service";
import { resetPromotions } from "../../../store/actions/promotion";
import { resetForm } from "../../../store/actions/form";
import { resetTimeSlots } from "../../../store/actions/timeslots";
import { mobileMatchMedia, getUrlParameters } from '../../../util';
import { setGeoCity } from '../../../store/actions/app';
import { getGeo } from '../../../store/actions/geo';
import Toronto from './sketch/Toronto';
import Ottawa from './sketch/Ottawa';
import Vancouver from './sketch/Vancouver';

class Hero extends Component {
  constructor(props) {
    super(props);
    this.notificationCount = 0;
    this.state = {
      error: "",
      stickyLogo: false,
      city: null,
      notificationHeight: 0,
      isTouchDevice: false
    };
    this.autocomplete = null;
    this.onLogoClick = this.onLogoClick.bind(this);
    this.smoothScroll = this.smoothScroll.bind(this);
    this.resetError = this.resetError.bind(this);
    this.stickLogo = this.stickLogo.bind(this);
    this.int = null;

    this.openModal = this.openModal.bind(this);
    this.newOpenModal = this.newOpenModal.bind(this);
    this.checkTouchDevice = this.checkTouchDevice.bind(this);
  }

  componentDidMount() {
    this.checkTouchDevice();
    if (!this.props.isPageRequestFibreStream) {
      this.props.resetAll();
    }
    const city = this.getCityFromQueryString() || this.props.geoCity || null;
    this.setState({ city: city });
    if (!city) {
      this.props.getGeo();
    }

    this.stickLogo();
    window.addEventListener("scroll", this.stickLogo);
  }
  checkTouchDevice() {
    if ("ontouchstart" in document.documentElement) {
      this.setState({
        isTouchDevice: true
      })
    }
    else {
      this.setState({
        isTouchDevice: false
      })
    }
  }
  componentWillUnmount() {
    if (this.int) {
      clearInterval(this.int);
    }
    window.removeEventListener("scroll", this.stickLogo);
  }
  openModal() {
    this.props.setAutofocus(true);
    this.props.history.push('/check');
  }

  newOpenModal() {
    this.openModal();
  }

  resetError() {
    if (this.state.error) {
      this.setState({ error: null });
    }
  }

  smoothScroll(h, top) {
    let i = h;
    if (i > 50) {
      setTimeout(() => {
        window.scrollTo(i, i);
        this.smoothScroll(i - 100, i);
      }, 10);
    } else if (i > 0) {
      setTimeout(() => {
        window.scrollTo(i, i);
        this.smoothScroll(i - 1, i);
      }, 10);
    }
  }

  onLogoClick() {
    if (this.props.location.pathname === "/") {
      let scrollFromTop = window.pageYOffset;
      this.smoothScroll(scrollFromTop, scrollFromTop - 100);
    }
    else {
      this.props.history.push('/');
    }
  }

  stickLogo() {
    if (window.pageYOffset > 0) {
      document.querySelector("#stick_logo").classList.add("fixed__main-logo");
      document.querySelector("#stick_header").classList.add("bg--black");
      if (document.querySelector('.notification')) {
        const notificationDiv = document.querySelector('.notification');
        this.setState({
          notificationHeight: notificationDiv.offsetHeight
        })
      }
      else {
        this.setState({
          notificationHeight: 0
        })
      }
    } else if (window.pageYOffset < 72) {
      document
        .querySelector("#stick_logo")
        .classList.remove("fixed__main-logo");
      document.querySelector("#stick_header").classList.add("bg--black");
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.openAvailabilityModal && this.props.openAvailabilityModal) {
      this.openModal();
    }
  }

  getCityFromQueryString() {
    const params = getUrlParameters();
    const city = params["city"];
    if (city) {
      this.props.setGeoCity(city);
    }
    return city;
  }

  render() {
    const { stickyContext, geoCity } = this.props;
    const { error, city, notificationHeight, isTouchDevice } = this.state;
    const addressPlaceholderText = (mobileMatchMedia()) ? 'Start typing your address...' : 'Start typing your building address';
    const selectedCity = city || geoCity || null;
    const isToronto = ['Ottawa', 'British Columbia'].indexOf(selectedCity) === -1;
    return (
      <div
        className="ui inverted vertical segment center aligned pt-0"
        id="top_section"
      >
        <div className="top-section">
          <div className="logo__block">
            <Sticky
              context={stickyContext}
              offset={mobileMatchMedia() ? 0 : notificationHeight}
              id="stick_logo"
              className={classNames("sticky-logo-container")}
            >
              <h1
                className="no-decoration text-prime itc-mdbold main-logo cursor-pointer"
                onClick={this.onLogoClick}
              >
                <span>Fibre</span><span className="normal text-white itc-bk">Stream</span>
              </h1>
            </Sticky>
          </div>
          <div className="hero-text">
            {
                selectedCity === 'British Columbia' ?
                    (<React.Fragment>
                    <h2 className="h1 text-white">
                      Experience super-fast, unlimited internet
                    </h2>
                    <h2 className="h1 text-white">
                      for $50 monthly, limited time*
                    </h2>
                    </React.Fragment>)
                :
                    (<React.Fragment>
                    <h2 className="h1 text-white">
                      Experience super-fast, unlimited internet
                    </h2>
                    <h2 className="h1 text-white">
                      starting from $55 monthly*
                    </h2>
                    </React.Fragment>)
            }

          </div>
          <div className="ui middle aligned center aligned grid mx-0 my-0">
            <div className="column form-xs py-0">
              <form
                className="ui form my-0 check-address hero inverted-form home-form"
                onSubmit={e => e.preventDefault()}
              >
                <div
                  className={classNames("field", { "is-error": error })}
                  onClick={this.newOpenModal}
                >
                  <Input
                    disabled
                    type="text"
                    placeholder={addressPlaceholderText}
                  />
                </div>
              </form>
            </div>
          </div>
          <div className="ui grid centered my-0 mx-0">
            <div className="blink-dot">
              Available in{" "}
              <span className="xs-d-block"><a className={classNames("t-d-none", { "selected-city": isToronto })} href="/?city=Toronto">Toronto</a>, <a className={classNames("t-d-none", { "selected-city": selectedCity === "Ottawa" })} href="/?city=Ottawa">Ottawa</a>
               &#8203; and <a className={classNames("t-d-none", { "selected-city": selectedCity === "British Columbia" })} href="?city=British Columbia">Metro Vancouver</a>
              </span>
            </div>
          </div>
        </div>

        {
          isToronto && <Toronto isTouchDevice={isTouchDevice} />
        }
        {
          selectedCity === 'Ottawa' && <Ottawa isTouchDevice={isTouchDevice} />
        }
        {
          selectedCity === 'British Columbia' && <Vancouver isTouchDevice={isTouchDevice} />
        }

      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    address: state.connection.address,
    openAvailabilityModal: state.app.openAvailabilityModal,
    geoCity: state.app.geoCity,
    isPageRequestFibreStream: state.app.isPageRequestFibreStream
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetAll: () => {
      dispatch(resetConnection());
      dispatch(resetServices());
      dispatch(resetPromotions());
      dispatch(resetForm());
      dispatch(resetTimeSlots());
    },
    resetConnection: () => dispatch(resetConnection()),
    getGeo: () => dispatch(getGeo()),
    setGeoCity: (city) => dispatch(setGeoCity(city)),
    setAutofocus: (flag) => dispatch(setAutofocus(flag))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Hero)
);



// WEBPACK FOOTER //
// ./src/components/home/hero/Hero.js